import { useTranslation } from "react-i18next"
import { TextButton } from "../../components/Form/Button/TextButton"

export const PaymentStatus = ({row, label}) => {
    const {t} = useTranslation();
    if(row.status === 1){
        return (
            <TextButton color={"success"} label={label}>
                {t("Successfull")}
            </TextButton>
        )
    }
    if(row.status === 2 || row.status === 3){
        return (
            <TextButton color={"danger"} label={label}>
                {row.status === 2?t("Unsuccessfull"):t("Declined")}
            </TextButton>
        )
    }
    return (
        <TextButton color={"warning"} label={label}>
            {t("Pending")}
        </TextButton>
    )
}